import React from 'react';
import { formilyReact, Box, CnButton, CnDialog, CnEllipsis } from '@alife/cn-ui';
import Editor from '@monaco-editor/react';
var observer = formilyReact.observer;
var defaultJsExpn = "(formValues, state) => {\n  // return state.urlParams.xxxx;\n}";
var JsExpressionForm = observer(function (props) {
  var _React$useState = React.useState(false),
    visible = _React$useState[0],
    setVisible = _React$useState[1];
  var valueRef = React.useRef('');
  var handleClose = function handleClose() {
    return setVisible(false);
  };
  return /*#__PURE__*/React.createElement(Box, {
    style: {
      width: 0,
      flex: 1
    },
    justify: 'center'
  }, /*#__PURE__*/React.createElement(CnButton, {
    text: !!props.value,
    onClick: function onClick() {
      setVisible(!visible);
    }
  }, /*#__PURE__*/React.createElement(CnEllipsis, {
    style: {
      width: '100%'
    }
  }, props.value || '编辑js表达式')), /*#__PURE__*/React.createElement(CnDialog, {
    title: 'JS 表达式',
    visible: visible,
    onOk: function onOk() {
      props.onChange(valueRef.current || defaultJsExpn);
      setVisible(false);
    },
    onCancel: handleClose,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(Editor, {
    height: '120px',
    defaultLanguage: "javascript",
    defaultValue: defaultJsExpn,
    value: props.value,
    onChange: function onChange(value) {
      valueRef.current = value;
    }
  })));
});
export default JsExpressionForm;